import {
  TOUR_OPEN,
  FILTER_OPEN,
  PROMPT,
  SET_COORDINATES,
  SET_ZOOM,
  SET_INFO,
  SET_CAROUSEL,
} from "./types";

export const toggleTour = () => (dispatch, getState) => {
  const isTour = getState().settings.tour;
  dispatch({
    type: TOUR_OPEN,
    payload: !isTour,
  });
};

export const toggleFilter = (isFilter) => (dispatch) => {
  dispatch({
    type: FILTER_OPEN,
    payload: isFilter,
  });
};

export const setFirstVisit = () => (dispatch) => {
  dispatch({
    type: PROMPT,
    payload: false,
  });
};

export const setCoordinates = (lon, lat) => (dispatch) => {
  dispatch({
    type: SET_COORDINATES,
    payload: {
      longitude: lon,
      latitude: lat,
    },
  });
};

export const setZoom = (zoom) => (dispatch) => {
  dispatch({
    type: SET_ZOOM,
    payload: zoom,
  });
};

export const setInfo = (open, panel) => (dispatch) => {
  dispatch({
    type: SET_INFO,
    payload: {
      open,
      panel,
    },
  });
};

export const setCarousel = (carouselType) => (dispatch) => {
  dispatch({
    type: SET_CAROUSEL,
    payload: carouselType,
  });
};
